import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import './input.scss';

interface Props {
  isChecked?: boolean;
  label?: string;
  name?: string;
  onChange: (id: string) => void;
  value: string;
}

const CheckBox: FC<Props> = ({ isChecked, label, name, onChange, value }) => {
  const { t } = useTranslation();

  return (
    <div className='input-container checkbox'>
      <input type='checkbox' checked={isChecked} onChange={() => onChange(value)} />
      <p onClick={() => onChange(value)}>{name || t(label)}</p>
    </div>
  );
};

export default CheckBox;
